'use client'
import Image from "next/image";
import { useState } from "react";
import { FaPlay } from "react-icons/fa6";

function getYoutubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) {
      return u.pathname.slice(1); // youtu.be/VIDEOID
    }
    if (u.pathname.startsWith('/embed/')) {
      return u.pathname.split('/embed/')[1];
    }
    // standard watch?v= URLs
    return u.searchParams.get('v') || u.pathname.split('/').at(-1);
  } catch {
    // fallback if it's not a valid absolute URL
    return url.split('/').at(-1);
  }
}

const YoutubePreview = ({ height = '400', width = '1000', url, title, isMobile = false }) => {
  const [showVideo, setShowVideo] = useState(false);

  const videoId = getYoutubeId(url);
  const thumbnail = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <>
      {!showVideo ? (
        <div className="relative w-full aspect-video" onClick={() => setShowVideo(true)}>
          <Image
            src={thumbnail}
            fill
            alt="Video thumbnail"
            style={{ objectFit: "cover" }}
            priority={true}
          />
          <div className="absolute inset-0 flex items-center justify-center text-white">
            <div className="flex inset-0 justify-center items-center rounded-md bg-third w-[80px] h-[50px] cursor-pointer">
              <FaPlay size={32} />
            </div>
          </div>
        </div>
      ) : (
        <iframe
          width={width}
          height={height}
          src={`${embedUrl}?autoplay=1`}
          title="Property Video"
          frameBorder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay;"
          allowFullScreen={isMobile ? false : true}
        />
      )}
    </>
  )
}

export default YoutubePreview